import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/employee-daily-timescans', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const orgChartStructure = (Option = {}) => {
  return httpClient
    .get('/api/v1/employee-daily-timescans/org-chart-structures', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const position = (Option = {}) => {
  return httpClient
    .get('/api/v1/employee-daily-timescans/positions', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = data => {
  return httpClient
    .post('/api/v1/employee-daily-timescans/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const generateReport = data => {
  return httpClient
    .post('/api/v1/employee-daily-timescans/generate-report', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, orgChartStructure, position, exportExcel, generateReport }
